// extracted by mini-css-extract-plugin
export default {"ScreenXSMax":"(max-width: 767px)","mainSection":"G9b1382","paddingElement":"G297a6e","orderedList":"Gfc0611","itemList":"Ga7e8e5"};